import {library} from "@fortawesome/fontawesome-svg-core";
import {faHandHoldingDollar} from "@fortawesome/free-solid-svg-icons";


export const initIcons = ()=>{
    library.add(faHandHoldingDollar)
}
